// eslint-disable-next-line import/no-default-export
export default {
    REDUCER_KEY: "REGISTRATION_DOCUMENT",
    ENTITY_NAME: "rentRegistrationDocument",
    RESOURCE: "rent-registration-documents",
};
